var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-canvas-wrapper"},[_c('canvas',{ref:"canvas",attrs:{"id":"treeCanvas","width":_vm.canvasWidth,"height":_vm.canvasHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }